import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequestsService } from 'src/app/services/http-requests.service';

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent implements OnInit {

  public categories: any = [];
  public actions: any = [];
  public expanded: boolean;
  public cities: any = [];
  public state = history.state.state;
  public action: any;

  constructor(private req: HttpRequestsService<any>, private router: Router) { }

  ngOnInit(): void {
    this.req.getAllActionCategories().subscribe((res) => {
      this.categories = res[0];
      this.categories.forEach(element => {
        element.expanded = false;
      });
    });
  }

  onClick(category: string) {
    this.categories.forEach(element => {
      element.expanded = (element.Action_Cat === category) ? !element.expanded : false;
    });
  
    if (this.categories.find(cat => cat.Action_Cat === category)?.expanded) {
      this.req.getAllActions(category).subscribe(res => this.actions = res);
    } else {
      this.actions = [];
    }
  }
  
  onActionClick(action) {
    this.actions.forEach(element => {
      if (element.Action === action.Action) {
        element.expanded = !element.expanded;
         this.action = action.Action;
        if (element.expanded && !element.cities) {
          this.req.getCitiesofActions(action.Action).subscribe(res => {
            element.cities = res;
          });
        }
      } else {
        element.expanded = false;
      }
    });
  }

  onCity(city) {
    this.router.navigateByUrl(`Evaluation/Action/${this.action.substring(0,5)}`, { state: { city: city.City, action: this.action } });
  }
}